import { render } from "./AdminLoginForm.vue?vue&type=template&id=40f1233b"
import script from "./AdminLoginForm.vue?vue&type=script&lang=js"
export * from "./AdminLoginForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__